export default class RuntimeException extends Error {
  constructor (message, cause) {
    super(message)
    this.cause = cause
  }
}



// WEBPACK FOOTER //
// ./src/util/RuntimeException.js